import {
    fetchRequestSend,
    getCookie,
    setCookie
} from "../../helpers/common-helpers";
import l10n from '../../lang/locallang';

export default class CatalogNavigationClass{
    constructor() {
        // Initialize the navigation
        this.initializeEventListeners();
    }

    /**
     * Initializes all necessary event listeners for navigation functionality.
     */
    initializeEventListeners() {
        this.openNextLevelEvent(); // Sets up listener for opening next level of navigation.
    }

    /**
     * Opens the next level of navigation.
     */
    openNextLevelEvent() {
        window.addEventListener('click', e => {
            if (e.target.closest('.open-topic__js')) {
                e.preventDefault();
                this.openNextLevel(e.target.closest('.open-topic__js'));
                this.menuStatus(e.target.closest('.open-topic__js'));
                let wrapper = document.querySelector('.flex-row.row-3-cols');
                // clear search input
                if(document.querySelector('.filed-box_item')){
                    document.querySelector('.filed-box_item').value = '';
                }

                this.changeURL(e.target.closest('.open-topic__js'));
                this.clearMyTrainingMenuStatus();
            }
        });
    }

    /**
     * Remove active class from My Training menu items
     */
    clearMyTrainingMenuStatus() {
        const myTrainingMenuItems = document.querySelectorAll('.open-course__js');

        if (myTrainingMenuItems) {
            myTrainingMenuItems.forEach(item => item.classList.remove('active'));
        }
    }

    /**
     * Update title text
     */
    updateTitle(title) {
        const titleBox = document.querySelector('.title-box');

        if (titleBox) {
            titleBox.querySelector('h2').innerText = title;
        }
    }


    /**
     * Opens the next level of navigation.
     */
    openNextLevel(element) {
        const { quickReferences, courses, topics } = l10n.catalog;
        let wrapper = document.querySelector('.flex-row.row-3-cols');
        let url = '';
        let titlePostfix = '';

        switch (wrapper.id) {
            case 'qr-list':
                if(element.dataset.level === 'topic'){
                    url = getQrSubTopics;
                    titlePostfix = topics;
                } else {
                    url = getSubTopicQrs;
                    titlePostfix = quickReferences;
                }
                break;
            case 'catalog-list':
                if(element.dataset.level === 'topic'){
                    url = getSubTopics;
                    titlePostfix = topics;
                } else {
                    url = getSubTopicCourses;
                    titlePostfix = courses;
                }
                break;
            default:
                break;
        }

        let comingSoonStatus = '';
        if(document.querySelector('#coming_soon')){
            let comingSoon = document.querySelector('#coming_soon');
            comingSoonStatus = comingSoon.checked ? 'true' : 'false';
        }

        let body = {
            parent_topic_id: element.dataset.topic,
            sub_topic_id: element.dataset.topic,
            coming_soon: comingSoonStatus, //Defined in catalog.js
        };
        ////console.log(body)
        // list with new elements
        fetchRequestSend(url, 'POST', body).then(data => {
            let list = [];
            let type = '';
            if (data.status) {
                if(data.sub_topics){
                    list = data.sub_topics;
                    type = 'topic';
                    this.updateTitle(`${data.parent_topic_name} ${titlePostfix}`);
                } else if(data.courses) {
                    list = data.courses;
                    type = 'course';
                    this.updateTitle(`${data.parent_topic_name} ${titlePostfix}`);
                } else if(data.response) {
                    list = data.response;
                    type = 'response';
                    this.updateTitle(`${data.sub_topic_name} ${titlePostfix}`);
                }
                this.renderTiles(list, wrapper.id, type, false, data);
            }
        });
    }

    changeURL(element) {
        let section = 'cg-courses';
        if(document.querySelector('#qr-list')){
            //return false;
            if(document.querySelector('#qr-webform-popup')){
                section = 'quick-references';
            } else {
                section = 'references';
            }
        }
        let slug = element.dataset.slug;
        if (!slug) {
            return false;
        }

        let currentUrl = new URL(window.location.href);
        let urlParts = currentUrl.pathname.split('/').filter(part => part);

        // Check if the URL contains 'catalog'
        let catalogIndex = urlParts.indexOf(section);
        let isChildSubject = element.closest('.catalog-menu_submenu') !== null;

        if(element.dataset.level === 'topic'){
            isChildSubject = false;
        } else {
            isChildSubject = true;
        }

        if (catalogIndex === -1) {
            // 'catalog' not in URL, add it
            urlParts.unshift(section);
            catalogIndex = 0;
        }
        // Update the URL parts based on level
        if (isChildSubject) {
            // Level 2 - Replace or add child subject slug
            // Ensure there's a place for the child slug
            if (urlParts.length === catalogIndex + 1) {
                urlParts.push('placeholder-subject');
            }
            urlParts[catalogIndex + 2] = slug; // Add/replace child subject slug
        } else {
            // Level 1 - Replace or add subject slug
            urlParts[catalogIndex + 1] = slug;
            // Remove child subject slug if exists
            if (urlParts.length > catalogIndex + 2) {
                urlParts.splice(catalogIndex + 2);
            }
        }

        currentUrl.pathname = '/' + urlParts.join('/');
        window.history.pushState({}, '', currentUrl);

        return true;
    }


    /**
     * Renders the tiles for the next level of navigation.
     */
    renderTiles(data, wrapperId, type, isSearch = false, response = null) {
        let wrapper = document.getElementById(wrapperId);
        let tiles = '';

        data.forEach(item => {
            tiles += this.renderTile(item, wrapperId, type, isSearch);
        });
        wrapper.innerHTML = tiles;
        // remove __hidden class one by one to animate
        setTimeout(() => {
            wrapper.querySelectorAll('.__hidden').forEach((element, index) => {
                element.classList.remove('__hidden');
            });
        }, 50);
    }

    /**
     * Renders a tile for the next level of navigation.
     */
    renderTile(item, wrapperId, type, isSearch = false) {
        const { quickReference, course } = l10n.catalog;
        let item_type = wrapperId === 'qr-list' ? quickReference : course;
        let topic_image = '';

        // Generate a unique ID for this tile image.
        const tileImageId = 'tile-image-' + (item.id || Math.random().toString(36).substr(2,9));

        // Render the tile with a fallback image.
        if (item.cover_image) {
            topic_image = `<img id="${tileImageId}" src="${window.location.origin + webrootPath + this.replaceImagesToThumbnails(item.cover_image)}" alt="${item.name}" loading="lazy">`;
        } else if (item.qr_cover_image) {
            topic_image = `<img id="${tileImageId}" src="${window.location.origin + webrootPath + 'images/cover-images/' + item.slug + '.webp'}" alt="${item.name}" loading="lazy">`;
        } else if (item.courseware) {
            topic_image = `<img id="${tileImageId}" src="${item.courseware[0].image_url}" alt="${item.name}" loading="lazy">`;
        } else {
            topic_image = `<img id="${tileImageId}" src="${window.location.origin + webrootPath + 'images/placeholder-image.png'}" alt="${item.name}" loading="lazy">`;
        }

        // Immediately initiate the asynchronous fetch for the cover image.
        this.getCoverImage(item)
            .then(([coverImage, coverType]) => {
                //console.log("Cover Image URL:", coverImage);
                //console.log("Cover Type:", coverType);
                if (coverImage && coverType === 'image') {
                    // When the promise resolves, update the image element's src.
                    const imgElem = document.getElementById(tileImageId);
                    if (imgElem) {
                        imgElem.src = coverImage;
                    }
                }
            })
            .catch(error => {
                console.error("Error fetching cover image:", error);
            });

        // Continue building the rest of the tile as before.
        let topic_icon = '<span class="icon_wr"><img src="/' + item.topic_icon + '"></span>';
        let url_course = '#';
        let block_class = '';
        let subitems = '';
        let data_attr = '';

        if (item.modules) {
            for (let i = 0; i < item.modules.length; i++) {
                subitems += `<li>${item.modules[i].name}</li>`;
            }
        } else if (item.courses) {
            for (let i = 0; i < item.courses.length; i++) {
                subitems += `<li>${item.courses[i].name}</li>`;
            }
        } else if (item.courseware) {
            for (let i = 0; i < item.courseware.length; i++) {
                subitems += `<li>${item.courseware[i].name}</li>`;
            }
        }

        let class_js = '';
        switch (type) {
            case 'topic':
            case 'course':
                class_js = 'open-topic__js';
                break;
            case 'response':
                class_js = '';
                break;
            default:
                break;
        }
        if (isSearch) {
            class_js = '';
            data_attr = `data-url="${item.url}" data-slug="${item.slug}" data-topic="${item.id}" data-level="topic"`;
        }
        if (item.courseware) {
            class_js = 'download-courseware__js';
            data_attr = `data-url="${item.courseware[0].document_public_url}" data-cw_name="${item.name}" data-qr_id="${item.courseware[0].id}"`;
        }
        if (item.courseware) {
            url_course = item.courseware[0].qr_url ? item.courseware[0].qr_url : '#';
        } else {
            url_course = typeof coursePageUrl !== 'undefined' ? coursePageUrl + '/' + item.slug : '#';
        }

        let tile = `
        <div class="col">
            <a href="${url_course}" class="course-tile __hidden ${class_js} ${block_class}" data-slug="${item.slug}" data-topic="${item.id}" data-level="subtopic" ${data_attr}>
                <div class="course-tile_head">
                    <div class="course-tile_cover">
                        ${topic_image}
                    </div>
                </div>
                <div class="course-tile_body">
                    <div class="course-tile_title">
                        <h3>${item.name}</h3>
                    </div>
                    <div class="course-tile_description">
                        <ul>
                            ${subitems}
                        </ul>
                    </div>
                </div>
                <div class="course-tile_footer">
                    ${item.course_count ? `<span>${item.course_count} ${item.course_count > 1 ? item_type + 's' : item_type}</span>` : ''}
                    ${item.ce_hours && typeof userType === 'undefined' ? `<span><i class="icon icon-cg-small"></i>${item.ce_hours}</span>` : ''}
                    ${
            typeof userType !== 'undefined' && item.owner_icon && item.ce_hours
                ? `<span class="course-tile_hours">
                            <img
                                src="${item.owner_icon}"
                                alt="Account Icon"
                                id="accountIcon"
                                width="18"
                                height="18"
                                class="course-tile_owner-icon"
                            >
                            ${item.ce_hours}
                          </span>`
                : ''
        }
                </div>
            </a>
        </div>`;

        if (item.courseware) {
            tile = `
            <div class="col">
                <div class="quick-reference-item __hidden">
                    <a href="${url_course}" target="_blank" class=" ${class_js}" ${data_attr}>
                        ${topic_image}
                    </a>
                </div>
            </div>
        `;
        }
        return tile;
    }


    menuStatus(button) {
        if (button.closest('.sidebar')) {
            // if it's sidebar menu, add active class to the button
            if (button.closest('.__has-submenu')) {
                // remove active class from other button, not from current
                let buttons = button.closest('.sidebar').querySelectorAll('.open-topic__js');
                buttons.forEach((btn) => {
                    if (btn != button) {
                        if (btn.classList.contains('active')) {
                            btn.classList.remove('active');
                            if (btn.closest('.__has-submenu')) {
                                btn.closest('.__has-submenu').classList.remove('active');
                            }
                        }
                    }
                });
                // if button haven't active class, add it
                if (!button.classList.contains('active')) {
                    button.classList.add('active');
                    button.closest('.__has-submenu').classList.add('active');
                } else {
                    button.classList.remove('active');
                    if (button.closest('.__has-submenu').classList.contains('active')) {
                        button.closest('.__has-submenu').classList.remove('active');
                    }
                }
            }
        }
        if (button.closest('#catalog-list')) {
            // add active class to sidebar menu, if was clicked to button in catalog list
            let topic_id = button.getAttribute('data-topic');
            let sidebar_button = document.querySelector(`.sidebar .open-topic__js[data-topic="${topic_id}"]`);
            if (sidebar_button) {
                // remove active class from other button, not from current
                let buttons = document.querySelector('.sidebar').querySelectorAll('.open-topic__js');
                buttons.forEach((btn) => {
                    if (btn != sidebar_button) {
                        if (btn.classList.contains('active')) {
                            btn.classList.remove('active');
                            btn.closest('.__has-submenu').classList.remove('active');
                        }
                    }
                });
                sidebar_button.classList.add('active');
                if (sidebar_button.closest('.__has-submenu')) {
                    sidebar_button.closest('.__has-submenu').classList.add('active');
                }
            }
        }
    }

    replaceImagesToThumbnails(image) {
        //console.log(image)
        if(!image){
            return false;
        }

        if(typeof(image) === 'object') {
            return false;
        }
        // Your original path
        let originalPath = image;

        // Get the directory and filename components
        let pathInfo = originalPath.split('/');
        let directory = pathInfo.slice(0, -1).join('/');
        ////console.log(directory)
        let filenameWithExtension = pathInfo[pathInfo.length - 1].split('.');
        let filename = filenameWithExtension.slice(0, -1).join('');
        let extension = filenameWithExtension[filenameWithExtension.length - 1];

        // Modify the filename for the thumbnail
        let newFilename = filename + '_thumb.' + extension;
        let thumbnailPath = directory + '/thumbnails/' + newFilename;
        ////console.log(thumbnailPath)
        //url to domain + path to image
        let absolutePath = window.location.origin + webrootPath + thumbnailPath;
        ////console.log(absolutePath)
        fetch(absolutePath)
            .then(response => {
                if (response.status === 200) {
                    return thumbnailPath;
                } else {
                    return originalPath;
                }
            })
            .catch(error => console.error('Fetch Error:', error));

        return thumbnailPath
    }

    /**
     * Retrieves the cover image URL and its type based on the course data.
     *
     * @param {Object} course - The course object containing cover_image or subjects_new.cover_image.
     * @returns {Promise<Array>} - A promise that resolves to an array: [coverImage, coverType]
     */
    async getCoverImage(course) {
        // Define your webroot. Here we assume the base URL is the current origin.
        const webroot = window.location.origin + '/';
        let coverImage = null;
        let coverType = 'image';

        // Check if course has a cover_image property
        if (course.cover_image) {
            let cover = course.cover_image;
            try {
                // Try to parse cover as JSON.
                const parsed = JSON.parse(cover);

                if (parsed && parsed.type) {
                    switch (parsed.type) {
                        case 'image':
                            coverImage = parsed.url;
                            break;
                        case 'color':
                            coverImage = parsed.color;
                            coverType = 'color';
                            break;
                        case 'gradient':
                            // Join the gradient array values with commas.
                            coverImage = 'linear-gradient(' + parsed.gradient.join(',') + ')';
                            coverType = 'gradient';
                            break;
                        default:
                            // Unknown type - fallback to treating it as a plain string.
                            coverImage = webroot + cover;
                            break;
                    }
                } else {
                    // If parsed JSON does not have a "type", fallback to plain string.
                    coverImage = webroot + cover;
                }
            } catch (e) {
                // If JSON.parse fails, treat cover as a plain string path.
                coverImage = webroot + cover;
            }
        } else if (course.subjects_new && course.subjects_new.cover_image) {
            // Fallback: use subjects_new cover image if course.cover_image is not available.
            coverImage = webroot + course.subjects_new.cover_image;
        }

        // If the cover is an image and the URL starts with digits followed by a slash,
        // assume it's an S3 image and fetch the CloudFront URL.
        if (coverType === 'image' && coverImage && /^\d+\//.test(coverImage)) {
            //console.log(coverImage)
            const cloudFrontUrl = await this.getCloudFrontContent(coverImage);
            if (cloudFrontUrl) {
                coverImage = cloudFrontUrl;
            }
        }

        return [coverImage, coverType];
    }

    /**
     * Fetches the CloudFront (S3) URL for the given image path.
     *
     * @param {string} imageUrl - The image URL (path) starting with "1/" or "2/".
     * @returns {Promise<string|boolean>} - A promise that resolves to the actual URL, or false if failed.
     */
    async getCloudFrontContent(imageUrl) {
        //console.log('Fetching CloudFront content for:', imageUrl);
        // Prepare the data to be sent in the POST request.
        const data = {
            path: imageUrl,
            isCustomContent: true
        };

        try {
            const response = await fetch('/aws/get-cloud-front-content', {
                method: 'POST',
                body: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                },
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const jsonResponse = await response.json();
            return jsonResponse.url;
        } catch (error) {
            console.error('Failed to fetch URL:', error);
            return false;
        }
    }

}
